/**
 * Map tile source abstraction. Currently uses 国土地理院 淡色地図 — a
 * muted, road-light raster tile set from the Geospatial Information
 * Authority of Japan. Free to use with attribution and no API key.
 *
 * Trade-offs we accept here:
 * - Coverage is Japan only (the choropleth and station data are also
 *   Japan-only so this matches the app's domain).
 * - Maximum native zoom is 18.
 * - Road outlines are still visible, but in light grey so the WBGT
 *   colour overlay reads cleanly above them.
 *
 * If we ever need a fully road-free base, switch to 国土地理院 ベクトル
 * タイル `optimal_bvmap-v1` with a hand-written maplibre style.
 */

export type TileSource = {
  id: string;
  tileUrls: string[];
  attribution: string;
  maxZoom: number;
  minZoom: number;
};

export const OSM_TILE_SOURCE: TileSource = {
  id: 'osm-raster',
  tileUrls: [
    'https://a.tile.openstreetmap.org/{z}/{x}/{y}.png',
    'https://b.tile.openstreetmap.org/{z}/{x}/{y}.png',
    'https://c.tile.openstreetmap.org/{z}/{x}/{y}.png',
  ],
  attribution: '© OpenStreetMap contributors',
  maxZoom: 19,
  minZoom: 3,
};

export const GSI_PALE_TILE_SOURCE: TileSource = {
  id: 'gsi-pale-raster',
  tileUrls: ['https://cyberjapandata.gsi.go.jp/xyz/pale/{z}/{x}/{y}.png'],
  attribution: '地図データ © <a href="https://maps.gsi.go.jp/development/ichiran.html" target="_blank" rel="noopener">国土地理院</a>',
  maxZoom: 18,
  minZoom: 3,
};

export const ACTIVE_TILE_SOURCE: TileSource = GSI_PALE_TILE_SOURCE;
